/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

export enum OrgRoleType {
  admin = 'admin',
  member = 'member'
}
